import React from 'react';
import { IconFacebook, IconInstagram, IconTiktok, IconX, IconYoutube } from '../CustomIcons';

interface Props {
  leagueData: any;
}

export default function SocialLinksRender({ leagueData }: Props) {
  if (!leagueData) return null;

  const { tiktok, youtube, facebook, instagram, x } = leagueData;

  const open = (link?: string) => {
    if (!link) return;
    try {
      window.open(link, '_blank');
    } catch (e) {
      // noop
    }
  };

  return (
    <div className="socialBtnWrap">
      {tiktok && (
        <div onClick={() => open(tiktok)} role="button" tabIndex={0} aria-label="Open TikTok">
          <IconTiktok />
        </div>
      )}
      {youtube && (
        <div onClick={() => open(youtube)} role="button" tabIndex={0} aria-label="Open YouTube">
          <IconYoutube />
        </div>
      )}
      {facebook && (
        <div onClick={() => open(facebook)} role="button" tabIndex={0} aria-label="Open Facebook">
          <IconFacebook />
        </div>
      )}
      {instagram && (
        <div onClick={() => open(instagram)} role="button" tabIndex={0} aria-label="Open Instagram">
          <IconInstagram />
        </div>
      )}
      {x && (
        <div onClick={() => open(x)} role="button" tabIndex={0} aria-label="Open X">
          <IconX />
        </div>
      )}
    </div>
  );
}
